import template from  './fuel_surcharges.html';
import controller from './fuel_surcharges.controller';
import './fuel_surcharges.scss';

let FuelSurchargesComponent = {
    restrict: 'E',
    template,
    controller
}

export default FuelSurchargesComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/fuel_surcharges.component.js